import { createAction, props } from '@ngrx/store';
import { UnitAllData } from '../../../units/models/unit-all-data';
import { UnitStats } from '../../../units/models/unit-stats';

export const mergePositionsWithUnits = createAction(
  '[UnitAllData] Merge Positions With Units',
  props<{unitAllData: UnitAllData[]}>()
);

export const updateUnits = createAction(
  '[UnitAllData] Update Units',
  props<{unitAllData: UnitAllData[]}>()
);

export const selectUnit = createAction(
  '[UnitAllData] Select Unit',
  props<{unitData: UnitAllData}>()
);
export const selectUnits = createAction(
  '[UnitAllData] Select Units',
  props<{unitData: UnitAllData[]}>()
);

export const zoomUnit = createAction(
  '[UnitAllData] Zoom Unit',
  props<{unitData: UnitAllData}>()
);

export const prepareUnitsStats = createAction(
  '[UnitAllData] Prepare Units Stats',
  props<{unitAllData: UnitAllData[]}>()
);

export const setUnitsStats = createAction(
  '[UnitAllData] Set Units Stats',
  props<{unitStats: UnitStats}>()
);

export type UnitAllDataActionsUnion = ReturnType<
  typeof mergePositionsWithUnits |
  typeof selectUnit |
  typeof selectUnits |
  typeof zoomUnit |
  typeof updateUnits |
  typeof prepareUnitsStats |
  typeof setUnitsStats
  >;
